// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.WorkerTasksDiv
{
    position: absolute;
    background-color: var(--dialog-content-backcolor);
    color: white;
    border-radius : 8px;
    display: flex;
    flex-direction: column;
    -webkit-user-select: none;
            user-select: none;

    border: solid;
    border-width: 2px;
    border-color: var(--default-icon-color);
    padding-bottom: 5px;

    z-index: 20;

    max-height: 400px;   /* hauteur maximale */
    overflow-y: auto;    /* scroll si le contenu dépasse */    


}

.WorkerTasksList
{
    margin: 8px;
}


.WorkerTasksTitle
{
    padding-top: 5px;
    background-color: var(--dialog-title-backcolor);
    border-top-left-radius : 8px;
    border-top-right-radius : 8px;
    color: white;
    height: 20px;
    font-size: 12px;
    text-align: center;
    display: flex;
    white-space: nowrap;

}
.WorkerTasksCloseButton
{
    width: 20px;
    background-color: transparent;
}
.WorkerTasksTitleText
{
    
    background-color: transparent;
    width: calc(100% - 30px);
    white-space: nowrap;
    padding-left: 20px;
    padding-right: 20px;
    
    

}
`, "",{"version":3,"sources":["webpack://./src/workertasks/workertasks.css"],"names":[],"mappings":";;AAEA;;IAEI,kBAAkB;IAClB,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;;IAEnB,WAAW;;IAEX,iBAAiB,IAAI,qBAAqB;IAC1C,gBAAgB,KAAK,iCAAiC;;;AAG1D;;AAEA;;IAEI,WAAW;AACf;;;AAGA;;IAEI,gBAAgB;IAChB,+CAA+C;IAC/C,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;;AAEvB;AACA;;IAEI,WAAW;IACX,6BAA6B;AACjC;AACA;;;IAGI,6BAA6B;IAC7B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;;;;AAIvB","sourcesContent":["\n\n.WorkerTasksDiv\n{\n    position: absolute;\n    background-color: var(--dialog-content-backcolor);\n    color: white;\n    border-radius : 8px;\n    display: flex;\n    flex-direction: column;\n    user-select: none;\n\n    border: solid;\n    border-width: 2px;\n    border-color: var(--default-icon-color);\n    padding-bottom: 5px;\n\n    z-index: 20;\n\n    max-height: 400px;   /* hauteur maximale */\n    overflow-y: auto;    /* scroll si le contenu dépasse */    \n\n\n}\n\n.WorkerTasksList\n{\n    margin: 8px;\n}\n\n\n.WorkerTasksTitle\n{\n    padding-top: 5px;\n    background-color: var(--dialog-title-backcolor);\n    border-top-left-radius : 8px;\n    border-top-right-radius : 8px;\n    color: white;\n    height: 20px;\n    font-size: 12px;\n    text-align: center;\n    display: flex;\n    white-space: nowrap;\n\n}\n.WorkerTasksCloseButton\n{\n    width: 20px;\n    background-color: transparent;\n}\n.WorkerTasksTitleText\n{\n    \n    background-color: transparent;\n    width: calc(100% - 30px);\n    white-space: nowrap;\n    padding-left: 20px;\n    padding-right: 20px;\n    \n    \n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
